import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
let addressInput = class addressInput extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      required: "1",
      jsonConfig: {
        showIndex: true,
        addressType: "p_c_a"
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], addressInput.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], addressInput.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], addressInput.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], addressInput.prototype, "watchPostForm", null);
addressInput = __decorate([Component({
  name: "addressInput",
  components: {
    questionSettingTemplate
  }
})], addressInput);
export default addressInput;